export function hasAdvertisedDiscount(offer) {
  const value = Number(offer?.discountValue);
  return Number.isFinite(value) && value > 0;
}

export function formatDiscountOff(offer) {
  if (!hasAdvertisedDiscount(offer)) return "";
  if (offer.discountType === "percentage") return `${offer.discountValue}% off`;
  return `${offer.discountValue} off`;
}